const INDEX_PATTERN = /^[0-9]+$/
const INDEX_WITH_NEW_PATTERN = /^(([0-9]+)|-)$/

export default function setNestedValue(path, root, value) {
  if (!PROD) {
    if (path && path[0] === "") {
      console.warn("Path starts with leading /.", path)
    }
  }
  return traverseSetNestedValue(path, root || {}, value, 0)
}

function traverseSetNestedValue(path, target, value, index) {
  const key = path[index]

  if (!target) {
    if (INDEX_WITH_NEW_PATTERN.test(key)) {
      target = []
    } else {
      target = {}
    }
  }

  if (index === path.length - 1) {
    if (target[key] === value) {
      return target
    }

    return setValue(target, key, value)
  } else {
    const nested = target[key]

    if (!nested && value === undefined) {
      return target
    }

    const updated = traverseSetNestedValue(path, nested, value, index + 1)

    if (updated !== nested) {
      return setValue(target, key, updated)
    }

    return target
  }
}

function setValue(target, key, value) {
  if (INDEX_WITH_NEW_PATTERN.test(key)) {
    if (value === undefined) {
      if (key === "-") {
        return target
      }

      return target.splice(key, 1)
    } else {
      const copy = target.slice(0)

      if (key !== "-") {
        copy[key] = value
      } else {
        copy.push(value)
      }

      return copy
    }
  } else {
    if (value === undefined) {
      const { [key]: deletedKey, ...withoutKey } = target
      return withoutKey
    }

    return { ...target, [key]: value }
  }
}



// WEBPACK FOOTER //
// ../ui-kit/src/lib/nested-values/setNestedValue.js